import { render, staticRenderFns } from "./Revslider.vue?vue&type=template&id=1ba54c78&"
import script from "./Revslider.vue?vue&type=script&lang=js&"
export * from "./Revslider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports